var map = {
	"./AKanban.svg": 261,
	"./Agile.svg": 262,
	"./Analysis.svg": 263,
	"./Analytic.svg": 264,
	"./Appreciation.svg": 265,
	"./Bill.svg": 266,
	"./Brief Project.svg": 267,
	"./Coaching.svg": 268,
	"./Collaboration.svg": 269,
	"./Contract.svg": 270,
	"./Creativity.svg": 271,
	"./Deployment.svg": 272,
	"./File Security.svg": 273,
	"./Guide Book.svg": 274,
	"./ID card.svg": 275,
	"./Innovative.svg": 276,
	"./List.svg": 277,
	"./Manager.svg": 278,
	"./Message.svg": 279,
	"./Production.svg": 280,
	"./Profile.svg": 281,
	"./Schedule.svg": 282,
	"./Skill.svg": 283,
	"./Sprint.svg": 284,
	"./Task flow.svg": 285,
	"./Team Brainstorming.svg": 286,
	"./Time Management.svg": 287,
	"./Workflow.svg": 288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;